export default __webpack_public_path__ + "static/media/3sec_dash_thumb.1f72a63b.png";